import React from 'react';
import './InfoLine.css'

const InfoLine = (props) => {
    return ( 
        <div className='InfoLine'>
             <p className='LineName'>{props.LineName}</p>
             <p className='LineSub'>{props.LineSub}</p>
        </div>
     );
}
 
export default InfoLine;